module.exports = __webpack_public_path__ + "assets/img/jairo_mora_sandoval-523c76b5.jpg";